var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    viewBox: "0 0 57 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12967_183069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5.89648,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#009F3C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5.89648,
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_12967_183069)",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.499 23.8955C19.499 18.9246 23.5291 14.8945 28.5 14.8945C33.471 14.8945 37.501 18.9246 37.501 23.8955C37.501 28.8665 33.471 32.8965 28.5 32.8965C23.5291 32.8965 19.499 28.8665 19.499 23.8955ZM28.5 13.3945C22.7007 13.3945 17.999 18.0962 17.999 23.8955C17.999 29.6949 22.7007 34.3965 28.5 34.3965C34.2994 34.3965 39.001 29.6949 39.001 23.8955C39.001 18.0962 34.2994 13.3945 28.5 13.3945ZM34.289 19.8786C34.5458 19.5536 34.4906 19.082 34.1656 18.8251C33.8407 18.5683 33.369 18.6235 33.1122 18.9484L26.3142 27.5493L26.3141 27.5492L26.3057 27.5602C26.2973 27.5712 26.284 27.5847 26.2654 27.5975C26.1927 27.645 26.0945 27.625 26.0463 27.5529L26.0361 27.5381L23.9126 24.5244C23.674 24.1858 23.2061 24.1047 22.8675 24.3433C22.5289 24.5819 22.4478 25.0498 22.6864 25.3884L24.8056 28.3959C25.3171 29.1501 26.3432 29.3505 27.1014 28.843L27.1014 28.843L27.1047 28.8408C27.2495 28.7427 27.3829 28.6201 27.4946 28.4748L34.289 19.8786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12967_183069",
    x: 0.0384607,
    y: 0.665715,
    width: 56.9231,
    height: 56.9231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.23077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.23077
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12967_183069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12967_183069",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12967_183069",
    x1: 28.5,
    y1: 5.89648,
    x2: 28.5,
    y2: 41.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/DoneIcon.214508982d01d271c8fa957a997128b8.svg";
export { ForwardRef as ReactComponent };